<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router'
import { Toaster } from '@/components/ui/sonner'
import GlobalSearch from '@/components/GlobalSearch.vue'
import UpdateApp from './components/UpdateApp.vue'

declare const __COMMIT_HASH__: string

const commitHash = __COMMIT_HASH__.substr(0, 7)
</script>

<template>
  <Toaster />

  <div class="flex flex-col container max-w-256 m-auto px-4 pb-6 min-h-svh">
    <header class="sm:flex gap-4 pt-4 pb-8 items-center">
      <div
        class="scroll-m-20 pb-4 text-4xl font-extrabold tracking-tight lg:text-5xl text-slate-800"
      >
        <RouterLink to="/">😺 Nyanji</RouterLink>
      </div>
      <nav class="main-nav items-center ml-auto">
        <RouterLink to="/settings">Settings</RouterLink>
        <RouterLink to="/import">Import</RouterLink>
        <RouterLink to="/kanjis">Kanjis</RouterLink>
        <RouterLink to="/exercises" class="!text-green-700">Learn!</RouterLink>
        <GlobalSearch class="self-center" />
      </nav>
    </header>

    <UpdateApp />

    <RouterView />

    <div class="mt-auto text-sm opacity-25 sm:pb-4 text-center">ver. {{ commitHash }}</div>
  </div>
</template>
